import { t } from 'es6/services/localization';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_DAY = 86400;
const SECONDS_IN_WEEK = 604800;
const SECONDS_IN_YEAR = 31556736;
const SECONDS_IN_MONTH = SECONDS_IN_YEAR / 12;

const HUMAN_TIMES  = [
  [SECONDS_IN_MINUTE, 120, (time) => t('{time} minutes from now', { time })],
  [SECONDS_IN_HOUR, 48, (time) => t('{time} hours from now', { time })],
  [SECONDS_IN_DAY, 14, (time) => t('{time} days from now', { time })],
  [SECONDS_IN_WEEK, 9, (time) => t('{time} weeks from now', { time })],
  [SECONDS_IN_MONTH, 12, (time) => t('{time} months from now', { time })],
];

/**
 * Helper function for converting seconds into humanized time.
 *
 * @i18n less than a minute ago
 * @i18n about a minute ago
 * @i18n minutes ago
 * @i18n about an hour ago
 * @i18n hours ago
 * @i18n yesterday at
 * @i18n this week at
 * @i18n on this date with year at
 * @i18n on this date at
 * @i18n am
 * @i18n pm
 *
 * @param {Number} seconds
 * @returns {String}
 */
export function humanizedTime(seconds) {
  return $.humanized_time(seconds);
}

/**
 * Given a date object, provides relative time to study.
 *
 * If usePast is true, then will only return localized 'now' for
 * past items.
 *
 * @param {Date} date
 * @returns {String}
 */
export function relativeTime(date) {
  const now = Date.now();

  if (!date) {
    return '';
  }

  const diff = Math.floor(Math.abs(date - now) / 1000);

  if (date < now || diff < SECONDS_IN_MINUTE) {
    return t('now');
  }

  /**
   * Iterate through the times to see which range the time falls under.
   * At the end, get the actual difference and floor the value.
   */
  for (let i = 0; i < HUMAN_TIMES.length; i++) {
    const time = HUMAN_TIMES[i];
    const seconds = time[0];
    const limit = time[1];
    const stringMethod = time[2];

    if (diff < seconds * limit) {
      return stringMethod(Math.floor(diff / seconds));
    }
  }

  return t('over a year from now');
}
